import PublicBankLayout from "../Components/PublicBankLayout/PublicBankLayout";

import { NavLink } from 'react-router-dom';

import BankInfo from "../../../BankInfo.json"



const PublicBankHome = () => {



    return (
        <PublicBankLayout>


            <div
                className="d-flex align-items-center justify-content-between"
                style={{
                    backgroundColor: '#f5f5f5',
                    padding: '50px',
                    overflow: 'hidden',
                    position: 'relative',
                }}
            >


                <div style={{ maxWidth: '50%' }}>
                    <span style={{ fontWeight: 'bold', fontSize: '3rem', color: '#000' }}>
                        <span style={{ color: 'rgb(71 79 122)' }}>{BankInfo?.BankName}</span>
                    </span> <br />
                    <span style={{ fontWeight: 'bold', fontSize: '1rem', color: '#000' }}>
                        <span style={{ color: 'rgb(71 79 122)' }}>{BankInfo?.BankAddress}</span>
                    </span>
                    <ul
                        style={{
                            listStyleType: "none",
                            padding: 0,
                            marginTop: '20px',
                            color: '#555',
                        }}
                    >
                        <NavLink to={`/AccountPrint`}>
                            <li style={{ color: "#555" }}>✓  Account Print </li>
                        </NavLink>
                        <NavLink to={`/RemittanceCalculation`}>
                            <li style={{ color: "#555" }}>✓ Remittance Calculation </li>
                        </NavLink>
                        <NavLink to={`/DPSCalculation`}>
                            <li style={{ color: "#555" }}>✓ DPS Calculation </li>
                        </NavLink>
                        <NavLink to={`/FDRCalculation`}>
                            <li style={{ color: "#555" }}>✓ FDR Calculation </li>
                        </NavLink>
                        <NavLink to={`/LoanCalculation`}>
                            <li style={{ color: "#555" }}>✓ Loan Calculation </li>
                        </NavLink>
                        <li>
                            ✚ Need a new feature?&nbsp;
                            <NavLink to={`/ContactUs`}>
                                <u>
                                    <span style={{ color: "#333", fontWeight: "bold" }}>
                                        Contact us
                                    </span>
                                </u>
                            </NavLink>
                            &nbsp; to get it added!
                        </li>
                    </ul>
                </div>

                <div style={{ width: '50%', position: 'relative' }}>
                    {BankInfo?.OfficeImage ? (
                        <img
                            src={BankInfo?.OfficeImage}
                            alt="Business"
                            style={{ width: '100%', borderRadius: '5px' }}
                        />
                    ) : (
                        <p>No image available</p>
                    )}
                </div>
            </div>
        </PublicBankLayout>
    );
};

export default PublicBankHome;
